import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const audioApi = createApi({
  reducerPath: "audioApi",
  baseQuery: prepareBaseQuery("/audio/"),
  tagTypes: ["Audio"],
  endpoints: (builder) => ({
    getAllAudio: builder.query({
      query: ({ page = 1, limit = 5, category, search } = {}) => ({
        url: "",
        params: { page, limit, category, search },
      }),
      providesTags: ["Audio"],
    }),
    getAllAudioAdmin: builder.query({
      query: ({ page = 1, limit = 5, category, search } = {}) => ({
        url: "admin",
        params: { page, limit, category, search },
      }),
      providesTags: ["Audio"],
    }),
    getAudioById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "Audio", id }],
    }),
    getAudioBySlug: builder.query({
      query: (slug) => `/slug/${slug}`,
      providesTags: (result, error, slug) => [{ type: "Audio", id: slug }],
    }),
    getAudioByCategory: builder.query({
      query: (category) => `/category/${category}`,
      providesTags: ["Audio"],
    }),
    uploadAudio: builder.mutation({
      query: (formData) => ({
        url: "",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Audio"],
    }),
    updateAudio: builder.mutation({
      query: ({ id, ...updates }) => ({
        url: `/${id}`,
        method: "PUT",
        body: updates,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Audio", id }],
    }),
    deleteAudio: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Audio"],
    }),
    incrementPlayCount: builder.mutation({
      query: (id) => ({
        url: `/${id}/play`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Audio", id }],
    }),
  }),
});

export const {
  useGetAllAudioQuery,
  useGetAllAudioAdminQuery,
  useGetAudioByIdQuery,
  useGetAudioBySlugQuery,
  useGetAudioByCategoryQuery,
  useUploadAudioMutation,
  useUpdateAudioMutation,
  useDeleteAudioMutation,
  useIncrementPlayCountMutation,
} = audioApi;

export default audioApi;
export { audioApi };
